import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';

type VenueConfigEmptyStateProps = {
  message: string;
};

export const VenueConfigEmptyState: FC<VenueConfigEmptyStateProps> = ({ message }) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    textAlign="center"
    sx={{ py: 4, px: 2, width: '100%' }}>
    <WarningAmberOutlinedIcon sx={{ fontSize: 48, color: 'warning.main', mb: 1.5 }} />
    <Typography variant="body2" color="warning.main" sx={{ maxWidth: 360 }}>
      {message}
    </Typography>
  </Box>
);
